import Bouncer from "formbouncerjs";
var validation = new Bouncer("form.js-validate");
var validationAjax = new Bouncer("form.js-validate-with-ajax", {
  disableSubmit: true,
  emitEvents: true
});
